export default __webpack_public_path__ + "static/media/card_1@3x.fd0ba102.png";